import { MonitorTypes, RECEIVE_MONITORS, REQUEST_MONITORS } from "./types";
import { AppThunkAction } from "..";
import * as services from "../service";
export const actionCreators = {
    requestMonitors:
        (forceFullyRefresh: boolean): AppThunkAction<MonitorTypes> =>
        (dispatch, getState) => {
            const appState = getState();
            if (
                appState != null &&
                appState.monitorData != null &&
                appState.monitorData.monitorData !== null &&
                ((appState.monitorData.monitorData.length === 0 && appState.monitorData.isLoading === false) || forceFullyRefresh === true)
            ) {
                services
                    .getMonitors()
                    .then((data) => {
                        dispatch({ type: RECEIVE_MONITORS, monitorData: data.data });
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_MONITORS, monitorData: [] });
                    });

                dispatch({ type: REQUEST_MONITORS });
            }
        },
};
